import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { DataService, TextDocument, TextDocumentVersion } from '../dataService';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private dataService: DataService) {}

  getLatestDocumentVersion(documentId: string): Observable<{
    document: TextDocument | null;
    isLoading: boolean;
    isError: boolean;
  }> {
    return this.dataService.getDocumentById(documentId).pipe(
      switchMap((document) => {
        if (!document || !document.versions || !document.versions[0]) {
          return of({
            document: null,
            isLoading: false,
            isError: true
          });
        }

        const latestVersionId = document.versions[0].id;
        return this.dataService.getDocumentVersionById(documentId, latestVersionId).pipe(
          map((documentVersion) => ({
            document: {
              ...document,
              versions: [documentVersion]
            },
            isLoading: false,
            isError: false
          })),
          catchError((error) => {
            console.error('Error fetching document version:', error);
            return of({
              document: null,
              isLoading: false,
              isError: true
            });
          })
        );
      }),
      catchError((error) => {
        console.error('Error fetching document:', error);
        return of({
          document: null,
          isLoading: false,
          isError: true
        });
      })
    );
  }
}
